import React from "react";

export const EventList = ({ events, date, ncolor, activeEventTypes }) => {
  const eventListItems = events.filter(event => {
    if (event.start === date.format("YYYYMMDD")) return event;
    if (event.range !== false && event.range.contains(date)) return event;
  });

  return (
    <ul>
      {eventListItems.map((event, index) => {
        let classes = [];
        if (event.created_by != null) classes.push("isUserEvent");
        return (
          <li key={index} className={Array.from(new Set(classes)).join(" ")}>
            {event.title}&nbsp;{(event.notes != "" && event.notes != null) && (<div style={{float:"right",cursor:"pointer"}}><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
            <path id="note-sticky-regular" d="M11.143,32H1.857A1.857,1.857,0,0,0,0,33.857v9.26A1.864,1.864,0,0,0,1.857,45H8.592a2.787,2.787,0,0,0,1.97-.816l1.622-1.622A2.827,2.827,0,0,0,13,40.592V33.857A1.863,1.863,0,0,0,11.143,32ZM1.529,43.471a.456.456,0,0,1-.136-.328v-9.26a.471.471,0,0,1,.464-.49h9.285a.471.471,0,0,1,.464.464v5.571H9.054a1.626,1.626,0,0,0-1.625,1.625v2.554H1.857A.456.456,0,0,1,1.529,43.471Zm8.05-.273a1.379,1.379,0,0,1-.757.386v-2.53a.233.233,0,0,1,.232-.232h2.531a1.378,1.378,0,0,1-.386.756Z" transform="translate(0 -32)" fill={ncolor}/>
          </svg></div>)}<br/>
            {event.start_time != '00:00' || event.end_time != '23:59' ? (<small className={'hours'}>{event.start_time} - {event.end_time} uur</small>):(<></>)}
          </li>
        );
      })}
    </ul>
  );
};

